import ReactAppController from "./react_app_controller"

export default class extends ReactAppController {
  constructor(props) {
    super(props)
    this.name = "soa_os_evolution_app_controller"
  }

  renderApp() {
    const appConfig = {
      locale: this.element.getAttribute("data-locale")
    }
    this.element.replaceChildren()
    this.app = __bmx__initSoaApp(this.element, appConfig)
  }
}
